var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1PilotingBySmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.32 11.25l-2.64 3a32.58 32.58 0 00-42.88 0l-2.63-3a36.58 36.58 0 0148.15 0zm-41.74 4.6L23 19a25 25 0 0130.43 0l2.44-3.16a29 29 0 00-35.32 0l.03.01zM52 30v39a4 4 0 01-4 4H29a4 4 0 01-4-4V30a4 4 0 014-4h19a4 4 0 014 4zm-4 0H29v39h19V30zm-9.76-9a17.7 17.7 0 017.88 1.83l1.77-3.58a21.82 21.82 0 00-19.3 0l1.77 3.58A17.7 17.7 0 0138.24 21zm.24 44a2 2 0 100-4 2 2 0 000 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Piloting_by_smartphone.d6d342d3.svg";
export { SvgG1PilotingBySmartphone as ReactComponent };